module.exports = __webpack_public_path__ + "static/media/meditating.65fe14b4.png";